import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { getFeaturedComics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = getFeaturedComics();

  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            编辑精选的高评分韩国漫画
          </p>
        </div>
        <Link
          to="/category/romance"
          className="text-sm text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
        >
          查看更多
          <i className="ri-arrow-right-line text-xs w-3 h-3 flex items-center justify-center"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-product-shop="">
        {featured.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}